import PatchOps from '@leverege/api-patch-ops'
import { updateAttribute } from './BlueprintActions'

/*
  Usage:
    let updater = AttributeUpdater( dispatch, blueprint, attribue )
      .set( "a/string/to/a/path", "value 1" )
      .set( "a/string/to/another/path", "value 2" )
      .done();
 */

function AttributeUpdater( dispatch, blueprint, attribute, key, value ) {
  
  const patchOps = PatchOps( key, value );

  patchOps.done = function( ) {
    dispatch( updateAttribute( blueprint, attribute, patchOps.ops() ) );

  }  

  return patchOps;
}

module.exports = AttributeUpdater;
